
<template>
    <div>
        <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
                <div class="card-icon">
                    <md-icon>request_quote</md-icon>
                </div>
            </md-card-header>

            <md-card-content>
                <ValidationObserver ref="valObserver">
                    <form>
                        <FadeTransition :duration="400" mode="out-in" v-if="!loading">
                            <div class="md-layout md-alignment-top-left">

                                <div class="md-layout-item md-small-size-100 md-medium-size-100 md-xlarge-size-50">
                                    
                                    <h1 class="page_title md-layout-item md-size-100">One Off Fee</h1>
                                    <h3>{{oneOffFee.buildingName}}</h3>
                                    <p class="margin_bottom">Provide the details for this non service charge invoice</p>

                                     <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-25 md-form-label top_pad_min">
                                            Bill to
                                        </label>
                                        <div class="md-layout-item">
                                            <md-radio v-for="option in billingOptions" v-model="billingOptionSelected" :key="option" :value="option">{{option}}</md-radio>
                                            <FadeTransition :duration="400" mode="out-in" v-if="billToTenant">
                                                <md-field class="margin_bottom margin_top">
                                                    <label for="tenantId">Choose Tenant</label>
                                                    <md-select v-model="oneOffFee.tenantId" name="tenantId" id="tenantId">
                                                        <md-option v-for="t in oneOffFee.tenants" :key="t.id" :value="t.id">{{t.name}}</md-option>
                                                    </md-select>
                                                </md-field>
                                            </FadeTransition>
                                        </div>
                                    </div>

                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-25 md-form-label">
                                            Description
                                        </label>
                                        <div class="md-layout-item">
                                            <ValidationProvider name="Description" rules="required|min:5|max:500" v-slot="{ passed, failed }">
                                                <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                                                    <md-textarea v-model="oneOffFee.description" md-autogrow></md-textarea>
                                                    <span class="md-helper-text">Suitable description of work (no more than 500 characters)</span>
                                                    <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                                                    <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                                                </md-field>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-25 md-form-label">
                                            Amount
                                        </label>
                                        <div class="md-layout-item md-size-40">
                                            <ValidationProvider name="Amount" rules="required|min_value:50|max_value:2147483647" v-slot="{ passed, failed }">
                                                <md-field class="val-inset" :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                                                    <span class="md-prefix">&pound;</span>
                                                    <md-input type="number" v-model="oneOffFee.value" min="50" step="100" max="2147483647"></md-input>
                                                    <span class="md-helper-text">Cost of Works for Invoice</span>
                                                    <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                                                    <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                                                </md-field>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                   

                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-25 md-form-label">
                                            Scheduled
                                        </label>
                                        <div class="md-layout-item md-size-40">
                                            <md-datepicker v-model="oneOffFee.scheduled" md-immediately>
                                            </md-datepicker>
                                        </div>
                                    </div>

                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-25 md-form-label">
                                            Completed
                                        </label>
                                        <div class="md-layout-item md-size-40">
                                            <md-datepicker v-model="oneOffFee.completed" md-immediately>
                                            </md-datepicker>
                                        </div>
                                    </div>

                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-25 md-form-label">
                                            Invoiced
                                        </label>
                                        <div class="md-layout-item md-size-40">
                                            <md-datepicker v-model="oneOffFee.invoiced" md-immediately>
                                            </md-datepicker>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </FadeTransition>
                        <div class="loader_wrap" v-if="loading">
                            <loader></loader>
                        </div>

                        <div class="stepper-buttons-wrap md-layout md-alignment-space-between">
                            <div class="md-layout-item md-alignment-top-right md-layout">
                                <md-button class="md-primary" @click="validatePageSaveOrAlert">Save</md-button>
                            </div>
                        </div>

                    </form>
                </ValidationObserver>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
    import { SlideYDownTransition } from "vue2-transitions";
    import { FadeTransition } from "vue2-transitions";
    import Loader from "@/components/Loader.vue";

    import { extend } from "vee-validate";
    import { required, email, min } from "vee-validate/dist/rules";
    extend("email", email);
    extend("required", required);
    extend("min", min);

    import Help from "@/ts/Help";
    import NotyTypes from "@/ts/NotyTypes";
    import Api from '@/ts/UvApiService';

    export default {
        components: {
            SlideYDownTransition
            , FadeTransition
            , Loader
        },
        data() {
            return {
                loading: true,
                buildingId: null,
                oneOffFee: null,
                billingOptions: ["Client", "Tenant..."],
                billingOptionSelected: "Client"
            }
        },
        methods: {
            getBillingOptionSelected() {
                return !Help.isNullOrUndef(this.oneOffFee) ? !Help.isNullOrUndef(this.oneOffFee.tenantId) ? "Tenant..." : "Client" : "Client";
            },
            showServerFailMessage(res, action) {
                var msg = res.message ?? `Unknown problem on the server ${action} this one off fee`;
                this.$notify({
                    timeout: 3500,
                    message: msg,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            done() {
                this.$router.push(`/one-off-fees`);

                setTimeout(() => {
                    this.$notify({
                        timeout: 8500,
                        message: `One Off Fee for <b>${this.oneOffFee.buildingName}</b> were saved`,
                        icon: "thumb_up",
                        horizontalAlign: "center",
                        verticalAlign: "top",
                        type: NotyTypes[NotyTypes.success],
                        animate: {
                            enter: 'animated fadeInDown',
                            exit: 'animated fadeOutUp'
                        }
                    });
                }, 600);
            },
            notifyErrors(errorsArray) {
                var errorsLis = "";

                errorsArray.forEach((e) => {
                    if (e.length > 0) {
                        e.flat().forEach((ei) => {
                            errorsLis += `<li>${Help.removeFullStop(ei)}</li>`;
                        });
                    }
                });

                this.$notify({
                    timeout: 2500,
                    message: `Please <b>fix all errors</b> on the current page <b>to proceed</b><ul>${errorsLis}</ul>`,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            async validatePageSaveOrAlert() {
                this.$refs.valObserver.validate().then(async success => {

                    if (!success) {

                        setTimeout(() => { //TODO: update vee validate timeout here is to ensure errors are there and correct https://github.com/logaretm/vee-validate/issues/2248#issuecomment-578229806
                            this.notifyErrors(Object.values(this.$refs.valObserver.errors));
                        }, 100);

                        return;
                    }
                    else {
                        if (!this.billToTenant) {
                            this.oneOffFee.tenantId = null;
                        }
                        await Api.oneOffFees.upsertOneOffFee(this.oneOffFee);
                        this.done();
                    }
                });
            }
        },


        computed: {
            billToTenant() {
                return this.billingOptionSelected === 'Tenant...';
            },
            //pageTitle() {
            //    var respVal = "New One Off Fee";
            //    if (this.isEditMode) {
            //        respVal = "Edit One Off Fee";
            //    }
            //    return respVal;
            //},
            isEditMode() {
                return !Help.isNullOrUndef(this.oneOffFee) && Help.isGoodNumber(this.oneOffFee.id) && this.oneOffFee.id > 0;
            }
        },
        async created() {
            if (!Help.isNullOrUndef(this.$route.params.oneOffFeeId)) {
                this.oneOffFee = await Api.oneOffFees.getOneOffFee(parseInt(this.$route.params.oneOffFeeId));
                this.billingOptionSelected = this.getBillingOptionSelected();
                this.loading = false;
            }
            if (!Help.isNullOrUndef(this.$route.params.buildingId)) {
                this.oneOffFee = await Api.oneOffFees.getEmptyOneOffFee(this.$route.params.buildingId);
                this.billingOptionSelected = this.getBillingOptionSelected();
                this.loading = false;
            }
        }
    }
</script>
<style lang="scss">
</style>

<!--maybe should have used cref https://vuejs.org/v2/guide/components.html#Dynamic-Components-->